import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';
import Input from '../components/common/Input';
import Button from '../components/common/Button';
import Loader from '../components/Loader';

const Login = () => {
   const [formData, setFormData] = useState({
      email: '',
      password: '',
   });
   const [loading, setLoading] = useState(false);
   const { login, isAuthenticated, loading: authLoading } = useAuth();
   const navigate = useNavigate();

   if (authLoading) {
      return (
         <div className="flex min-h-screen items-center justify-center">
            <Loader size="lg" />
         </div>
      );
   }

   if (isAuthenticated) {
      return <Navigate to="/admin" replace />;
   }

   const handleChange = (e) => {
      setFormData({
         ...formData,
         [e.target.name]: e.target.value,
      });
   };

   const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);

      try {
         const result = await login(formData);
         if (result.success) {
            navigate('/admin');
         } else {
            toast.error(result.error || 'Login failed. Please try again.');
         }
      } catch (err) {
         toast.error('An error occurred. Please try again.');
      } finally {
         setLoading(false);
      }
   };

   return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-dark-primary py-12 px-4 sm:px-6 lg:px-8">
         <div className="max-w-md w-full space-y-8">
            <div>
               <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-gray-100">
                  Sign in to Admin Panel
               </h2>
            </div>
            <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
               <div className="rounded-md shadow-sm flex flex-col gap-[12px]">
                  <Input
                     label="Email address"
                     name="email"
                     type="email"
                     value={formData.email}
                     onChange={handleChange}
                     placeholder="Email address"
                     required
                     className="rounded-t-md"
                  />
                  <Input
                     label="Password"
                     name="password"
                     type="password"
                     value={formData.password}
                     onChange={handleChange}
                     placeholder="Password"
                     required
                     className="rounded-b-md"
                  />
               </div>

               <div>
                  <Button
                     type="submit"
                     variant="primary"
                     size="lg"
                     disabled={loading}
                     className="w-full flex justify-center"
                  >
                     {loading ? (
                        <span className="flex items-center gap-2">
                           {' '}
                           <span>Signing in...</span> <Loader size="sm" />{' '}
                        </span>
                     ) : (
                        'Sign in'
                     )}
                  </Button>
               </div>
            </form>
         </div>
      </div>
   );
};

export default Login;
